module.exports = __webpack_public_path__ + "img/neu-logo.0d0c5b45.svg";